/**
 * Types
 */

import { Colors, Fonts } from "@/theme";
import styled from "styled-components";

interface BodyProps {
  text: string;
  color?: string;
  variant: "regular" | "bold";
  size?: "extra-small" | "small" | "medium";
}

/**
 * Styled Components
 */

const styles = {
  fontSize: {
    "extra-small": "12px",
    small: "14px",
    medium: "16px",
  },
  fontWeight: {
    regular: 450,
  },
  lineHeight: {
    "extra-small": "16px",
    small: "20px",
    medium: "24px",
  },
};

const StyledBody = styled.p<{
  $variant: "regular" | "bold";
  $color?: string;
  $size?: "extra-small" | "small" | "medium";
}>`
  font-size: ${({ $size }) => styles.fontSize[$size || "medium"]};
  font-weight: ${({ $variant }) => ($variant === "regular" ? 450 : "unset")};
  line-height: ${({ $size }) => styles.lineHeight[$size || "medium"]};
  color: ${({ $color }) => $color || Colors.gray400};
  font-family: ${({ $variant }) =>
    $variant === "bold" ? Fonts.ttNormsProBold : Fonts.ttNormsProNormal};
`;

/**
 * Body Component
 */

export const Body = ({
  text,
  variant = "regular",
  color,
  size = "medium",
}: BodyProps) => {
  return (
    <StyledBody
      $variant={variant}
      $color={color}
      $size={size}
      dangerouslySetInnerHTML={{
        __html: text,
      }}
    />
  );
};
